import { render, staticRenderFns } from "./IndividualForm.vue?vue&type=template&id=451064bc&scoped=true&"
import script from "./IndividualForm.vue?vue&type=script&lang=js&"
export * from "./IndividualForm.vue?vue&type=script&lang=js&"
import style0 from "./IndividualForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndividualForm.vue?vue&type=style&index=1&id=451064bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451064bc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
